<div class="geo-hub">
  <header class="hub-header">
    <div>
      <h1>Geospatial</h1>
      <p class="subtitle">
        Open GIS editing, linear referencing, and the asset registry as separate tools instead of dumping everything into one map screen.
      </p>
    </div>
  </header>

  <div class="cards">
    <article
      class="integration-card"
      *ngFor="let card of cards"
      (click)="openCard(card)"
      (keydown.enter)="openCard(card)"
      tabindex="0"
      role="button"
    >
      <div class="card-top">
        <div class="icon" [style.background]="card.accent">{{ card.iconLabel }}</div>
        <span class="badge badge-live">Open</span>
      </div>
      <h2>{{ card.name }}</h2>
      <p class="vendor">{{ card.blurb }}</p>
      <p class="desc">{{ card.description }}</p>
      <ul class="features">
        <li *ngFor="let f of card.features">{{ f }}</li>
      </ul>
      <div class="card-footer">
        <span class="setup-link">{{ card.cta }}</span>
      </div>
    </article>
  </div>

  <p class="alt-link">
    Need the NHAI-style workbench?
    <a routerLink="/home/gis-mvp">Open GIS MVP</a>
  </p>
</div>
